import { render, staticRenderFns } from "./buyList.vue?vue&type=template&id=19cb6680&"
import script from "./buyList.vue?vue&type=script&lang=js&"
export * from "./buyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports